import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

type WelcomeStatus = 'idle' | 'loading' | 'error'

interface WelcomeState {
  message: string
  count: number
  status: WelcomeStatus
}

const initialState: WelcomeState = {
  message: 'Developer',
  count: 0,
  status: 'idle',
}

export const fetchWelcomeMessage = createAsyncThunk<string>('welcome/fetchMessage', async () => {
  await new Promise((resolve) => setTimeout(resolve, 500))
  return 'Soniya'
})

const welcomeSlice = createSlice({
  name: 'welcome',
  initialState,
  reducers: {
    setMessage: (state, action: PayloadAction<string>) => {
      state.message = action.payload
    },
    increment: (state) => {
      state.count += 1
    },
    reset: (state) => {
      state.count = 0
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWelcomeMessage.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchWelcomeMessage.fulfilled, (state, action) => {
        state.status = 'idle'
        state.message = action.payload
      })
      .addCase(fetchWelcomeMessage.rejected, (state) => {
        state.status = 'error'
      })
  },
})

export const { increment, reset, setMessage } = welcomeSlice.actions
export default welcomeSlice.reducer
